import React from 'react';

export default function AppDe () {
  return (
    <main>
      <h2 className={'visually-hidden'}>App De</h2>
      <p>Coming soon...</p>
    </main>
  );
}

